import { actions } from '@/store/module/team/action/actions.js';
import { mutations } from '@/store/module/team/mutation/mutations.js';

export const team = {
	namespaced: true,

	state: {
		invitations: [],
		members: []
	},

	actions,
	mutations
};
